<template>
    <div class="clx__item js-clx-item">
        <div class="clx__top-level js-data-popup-open">
            <div class="clx__title">{{item.name}}</div>
            <div class="clx__count js-clx-count"></div>
            <svg class="svg-icon-right svg-icon" width="10" height="20">
                <use xlink:href="#right"></use>
            </svg>
        </div>
        <div class="clx__sub-level data-popup js-data-popup">
            <div class="data-popup__header">
                <div class="data-popup__title">{{item.name}}</div>
                <button class="close-btn data-popup__close-btn js-data-popup-close" type="button">
                    <svg class="svg-icon-close svg-icon" width="20" height="20">
                        <use xlink:href="#close"></use>
                    </svg>
                </button>
            </div>
            <div v-if="item.children"  class="scrollable js-scroll">
                <material-item v-for="category in item.children" :item="category" :products="products"></material-item>
            </div>
            <div v-else class="catalog scrollable js-scroll">
                <form v-for="product in item.products" class="catalog-item">
                    <div class="catalog-item__title">{{product.name}} ({{product.unit}})</div>
                    <button  v-if="product.cout_in_cart + '' == '0'"  @click="plusBasketCount(product.id)" class="catalog-item__buy-btn primary-btn" type="button">
                        <svg class="svg-icon-cart svg-icon" width="20" height="20">
                            <use xlink:href="#cart"></use>
                        </svg>
                        В корзину
                    </button>
                    <div v-else class="catalog-item__count count">
                        <button class="count__btn" @click="minusBasketCount(product.id)" type="button">&ndash;</button>
                        <input class="count__input js-input-basket-count" @input="updateCartCount(product.id)"  v-model="product.cout_in_cart" type="text" :value="product.cout_in_cart" />
                        <button class="count__btn" @click="plusBasketCount(product.id)" type="button">+</button>
                    </div>

                </form>
            </div>
            <div class="bottom-section">
                <button class="primary-btn lg-btn wide-btn js-data-popup-close" type="button"><span>Готово</span></button>
            </div>
        </div>
    </div>
</template>

<script>

    import MaterialList from '../components/MaterialList.vue'

    export default {
        props: ['item', 'products', 'basketPositions'],
        name:'material-item',
        mounted:function() {},
        created() {},
        components: {
            'material-item': MaterialList,
        },

        methods: {
            minusBasketCount: function(productId){
                let self = this;
                this.item.products.forEach(function(product, i){
                    if (productId == product.id){
                        let countInCart = parseInt(product.cout_in_cart) - 1;
                        if(countInCart < 0){
                            self.item.products[i].cout_in_cart = 0;
                        }else{
                            self.item.products[i].cout_in_cart = countInCart;
                        }
                        //self.products.$set(i, self.products[i]);
                        self.updateCartCount(productId)
                    }
                });
            },
            plusBasketCount: function(productId){
                let self = this;
                console.log(self.item);

                this.item.products.forEach(function(product, i){
                    if (productId == product.id){

                        if(isNaN(parseInt(product.cout_in_cart)))
                            product.cout_in_cart = 0;

                        let countInCart = parseInt(product.cout_in_cart) + 1;
                        self.item.products[i].cout_in_cart = countInCart;
                       // self.item.products.$set(i, self.item.products[i]);
                        self.updateCartCount(productId)
                    }
                });
            },

            updateCartCount(productId){
                let self = this;

                this.item.products.forEach(function(product, i) {
                    if (productId == product.id) {
                        console.log("update count");
                        console.log(product.id);

                        /*if(isNaN(parseInt(product.cout_in_cart)))
                            product.cout_in_cart = 0;*/

                        console.log(product.cout_in_cart);

                        const json = JSON.stringify({ product_id: parseInt(product.id), count: parseInt(product.cout_in_cart)});

                        //const res = await axios.post('https://httpbin.org/post', json);
                        if(!isNaN(parseInt(product.cout_in_cart)))
                            self.$root.instance.post(
                                '/basket/add',
                                json
                            ).then(function (response) {
                                console.log(response);
                                self.$store.dispatch("fetchStart");
                            });

                    }
                });

            }
        },
    };
</script>